import React from 'react'
import LazyComponent from '../../components/lazy-component'
import PropTypes from 'prop-types'

export const validationPropTypes = PropTypes.shape({
    isSubmitted: PropTypes.bool,
    isValid: PropTypes.bool,
    changedFields: PropTypes.array.isRequired,
    isChanged: PropTypes.bool,
    onFormInit: PropTypes.func.isRequired,
    onFormChanged: PropTypes.func.isRequired,
    onFormReset: PropTypes.func.isRequired,
    validationState: PropTypes.object.isRequired,
}).isRequired

export default function withValidation(ChildComponent) {
    class WithValidationWrapper extends LazyComponent {
        static propTypes = {
            isSubmitted: PropTypes.bool
        }

        constructor(props) {
            super(props)

            this.loadModules([
                '@gsm/object-validator'
            ])

            this.handleFormChanged = this.handleFormChanged.bind(this)
            this.handleFormInit = this.handleFormInit.bind(this)
            this.handleFormReset = this.handleFormReset.bind(this)

            Object.assign(this.state, {
                isValid: false,
                isChanged: false,
                validationErrors: {},
                validationState: {},
                changedFields: {}
            })
        }

        componentWillReceiveProps(nextProps) {
            if (nextProps.isSubmitted && !this.props.isSubmitted) {
                this.setState({ validationState: this.state.validationErrors })
            }
        }

        getFieldsToValidate(formData) {
            const fieldsToValidate = {}
            Object.keys(formData).map(key => {
                if (typeof formData[key]['value'] !== 'undefined') {
                    fieldsToValidate[key] = true
                }
            })
            return fieldsToValidate
        }

        handleFormReset(callback) {
            this.setState({
                isValid: false,
                isChanged: false,
                validationErrors: {},
                validationState: {},
                changedFields: {}
            }, callback)
        }

        handleFormInit(formData, metadata, showErrors) {
            const { validate } = this.modules['@gsm/object-validator']
            const { changedFields } = this.state

            const validationErrors = validate(formData, metadata, this.getFieldsToValidate(formData))
            const validationState = {}

            let isChanged = false
            const isValid = Object.keys(validationErrors)
                .reduce((valid, field) => {
                    const isFieldValid = validationErrors[field] === ''

                    if (!isFieldValid && (showErrors || this.props.isSubmitted)) {
                        changedFields[field] = true
                        validationState[field] = validationErrors[field]
                        isChanged = true
                    }

                    return valid && isFieldValid
                }, true)

            this.setState({
                isChanged,
                changedFields,
                isValid,
                validationErrors,
                validationState
            })
        }

        handleFormChanged(formData, metadata, changedField, callback) {
            const { validate } = this.modules['@gsm/object-validator']
            const { changedFields } = this.state
            changedFields[changedField] = true

            const validationErrors = validate(formData, metadata, this.getFieldsToValidate(formData))
            const validationState = {}

            const isValid = Object.keys(validationErrors)
                .reduce((valid, field) => {
                    const isFieldValid = validationErrors[field] === ''

                    if (!isFieldValid && (this.props.isSubmitted || formData[field].value || changedFields[field])) {
                        validationState[field] = validationErrors[field]
                    }

                    return valid && isFieldValid
                }, true)

            this.setState({
                isChanged: true,
                isValid,
                validationErrors,
                validationState,
                changedFields
            })

            callback(isValid)
        }

        lazyRender() {
            const { changedFields, ...others } =  this.state
            const validationProps = {
                ...others,
                isSubmitted: this.props.isSubmitted,
                changedFields: Object.keys(changedFields),
                onFormChanged: this.handleFormChanged,
                onFormInit: this.handleFormInit,
                onFormReset: this.handleFormReset
            }

            return (
                <ChildComponent
                    {...this.props}
                    validationProps={validationProps}
                />
            )
        }
    }

    return WithValidationWrapper
}



// WEBPACK FOOTER //
// src/containers/high-order-components/with-validation.js